import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MobileFlightDestination from '../MobileFlightDestination';
import MobilePaxDetailAirCard from '../MobilePaxDetailAirCard';
import MobileDateSelector from 'Components/MobileDateSelector';
import Toggle from 'Components/Toggle';
import { getMaxFlightDate } from '../../../../Utils/dates';

const MobileRoundTrip = ({
  className,
  knowDestination,
  isMPC,
  actions,
  initialDate,
  endDate,
  isCurrentViewDestinations
}) => (
  <div className={className}>
    <div className="container-main">
      <div className="container-top">
        <MobileFlightDestination />
      </div>
      <div className="container-bottom">
        <MobilePaxDetailAirCard />
        <MobileDateSelector
          arrivalDate={endDate}
          departureDate={initialDate}
          setArrivalDate={actions.setEndDate}
          setDepartureDate={actions.setInitialDate}
          maxDate={getMaxFlightDate()}
          isFlight
        />
      </div>
      <div className="container-checkboxes">
        {!isCurrentViewDestinations && (
          <Toggle
            size="medium"
            context="important"
            leftLabel="Conocer más"
            status={knowDestination}
            onToggle={actions.setKnowDestination}
          />
        )}

        <Toggle
          size="medium"
          context="important"
          leftLabel="Fechas cercanas"
          status={isMPC}
          onToggle={actions.toggleMPC}
        />
      </div>
    </div>
  </div>
);

MobileRoundTrip.propTypes = {
  className: PropTypes.string,
  validationMessages: PropTypes.object,
  actions: PropTypes.shape({
    toggleMPC: PropTypes.func.isRequired,
    setKnowDestination: PropTypes.func.isRequired,
    setInitialDate: PropTypes.func.isRequired,
    setEndDate: PropTypes.func.isRequired
  }),
  isMPC: PropTypes.bool,
  knowDestination: PropTypes.bool,
  initialDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  isCurrentViewDestinations: PropTypes.bool
};

export default styled(MobileRoundTrip)`
  .container-main {
    margin-top: ${({ theme }) => theme.spacing.one};
  }

  .container-bottom {
    display: flex;
    gap: ${({ theme }) => theme.spacing.two};
    margin-top: ${({ theme }) => theme.spacing.two};
    padding: 0;
    flex-direction: row;
    width: 100%;
    justify-content: center;
  }

  .container-checkboxes {
    display: flex;
    gap: ${({ theme }) => theme.spacing.two};
    justify-content: center;
    text-align: center;
    margin-top: ${({ theme }) => theme.spacing.three};
  }
`;
